import { RecuperarSenhaModel } from '../../projects/core/src/lib/core/model/RecuperarSenhaModel';
import { UsuarioModel } from '../../projects/core/src/lib/core/model/UsuarioModel';
import { AppSession } from '../../projects/core/src/lib/core/AppSession'

import { LoginModel } from '../../projects/core/src/lib/core/model/LoginModel';

import { DrawerMenuModel } from 'projects/core/src/lib/core/model/DrawerMenuModel';
import { AppComponent } from './app.component';
import { ContratoProvider } from 'projects/core/src/lib/core/provider/ContratoProvider';
import { TokenProvider } from 'projects/core/src/lib/core/provider/TokenProvider';
import { AppStorage } from 'projects/core/src/lib/core/AppStorage';

export class AppViewModel {

    login = new LoginModel()
    usuario = new UsuarioModel()
    recuperarSenha = new RecuperarSenhaModel()
    contratoProvider = new ContratoProvider()
    tokenProvider = new TokenProvider()

    context: AppComponent

    constructor() { }

    getContext(): AppComponent {
        return this.context
    }

    setContext(context: AppComponent) {
        this.context = context
    }

    async obtemUsuarioLogado(): Promise<UsuarioModel> {
        return await AppSession.getUser()
    }

    async obtemDrawerMenu() {
        this.getContext().setDrawerMenu(await DrawerMenuModel.getDrawerMenu())
    }

    async salvaNotificacaoLocal(notificacao: any) {
        var listaNotificacoes: Array<any> = await AppStorage.get(AppSession.CHAVE_LISTA_NOTIFICACOES)
        if (!listaNotificacoes) listaNotificacoes = []
        listaNotificacoes.push(notificacao)
        AppStorage.set(AppSession.CHAVE_LISTA_NOTIFICACOES, listaNotificacoes)
    }

    async buscaContratos() {
        const retorno = await this.contratoProvider.listaContratosPorUsuario()
        await AppStorage.set(AppSession.CHAVE_CONTRATO_USUARIO, retorno)
        this.getContext().setListaContratos(retorno)
    }

    async salvaTokenApi(fcmToken: string) {
        await this.tokenProvider.salvaTokenApi(fcmToken)
    }
}